import React from "react";
import { Helmet } from "react-helmet";

import Hero from "./Hero";
import Services from "./Services";
import About from "./About";
import Approach from "./Approach";
import Contact from "./Contact";

const Home = () => {
  return (
    <React.Fragment>
      <Helmet>
        <title>Corlea Geyer | Attorney and Conveyancer</title>
      </Helmet>
      <Hero />
      <Services />
      <About />
      <Approach />
      <Contact />
    </React.Fragment>
  );
};

export default Home;
